import React from 'react';

const OrderConfirmation = () => {
  return <h1>GREAT JOB! YOU BOUGHT SOMETHING</h1>;
};

export default OrderConfirmation;
